import { useAuthContext } from '@/shared/contexts/AuthContext';
import { Button } from '@develop-fapp/ui-kit-fapp';

import * as S from './styles';

interface HeaderHomePreLoginProps {
  onOpenModalAuth: () => void;
}

export const HeaderHomePreLogin: React.FC<HeaderHomePreLoginProps> = ({
  onOpenModalAuth,
}) => {
  const { isLoggedin } = useAuthContext();

  return (
    <S.HeaderWithOutUser>
      <div>
        <S.LogoExtended
          src="/static/images/fapp/logo/medium_extended.svg"
          alt="Logo FARMÁCIAS APP"
          height={32}
          width={110}
          loading="eager"
        />
        <S.LogoCompressed
          src="/static/images/fapp/logo/medium_compressed.svg"
          alt="Logo FARMÁCIAS APP"
          height={38}
          width={18}
          loading="eager"
        />

        {!isLoggedin && (
          <Button
            id="btn-access-account"
            color="primary"
            variant="contained"
            onClick={() => onOpenModalAuth()}
          >
            Acessar conta
          </Button>
        )}
      </div>
    </S.HeaderWithOutUser>
  );
};
